export const markerImages = {
    BAIXO: "/marker-icons/nivelDosRios/baixo.png",
    ALTO: "/marker-icons/nivelDosRios/alto.png",
    TRANSBORDANDO: "/marker-icons/nivelDosRios/transbordando.png",
    TRANSITAVEL: "/marker-icons/alagamentos/transitavel.png",
    INTRANSITAVEL: "/marker-icons/alagamentos/intransitavel.png",
    SEM_CHUVA: "/marker-icons/chuva/sem-chuva.png",
    CHUVA_FRACA: "/marker-icons/chuva/chuva-fraca.png",
    CHUVA_MODERADA: "/marker-icons/chuva/chuva-moderada.png",
    CHUVA_FORTE: "/marker-icons/chuva/chuva-forte.png",
    PERDA_SOLO: "/marker-icons/chuva/chuva-perda-de-solo.png",
    ENXURRADA: "/marker-icons/chuva/chuva-enxurrada.png",
    DANOS_ESTRUTURA: "/marker-icons/chuva/chuva-estrutura.png",
    TRINCA: "/marker-icons/barragem/trinca.png",
    FISSURA: "/marker-icons/barragem/fissura.png",
    FUGA_AGUA: "/marker-icons/barragem/fuga-dagua.png",
    VAZAMENTO: "/marker-icons/barragem/vazamento.png",
    CRESCIMENTO_VEGETACAO: "/marker-icons/barragem/vegetacao.png",
    OCUPACAO: "/marker-icons/barragem/ocupacao.png",
    CONSTRUCAO_IRREGULAR: "/marker-icons/barragem/construcao.png",
    QUEDA_ARVORES: "/marker-icons/vendaval/queda.png",
    DANOS_REDE_ELETRICA: "/marker-icons/vendaval/dano-a-rede-eletrica.png",
    DANOS_RESIDENCIAS: "/marker-icons/vendaval/dano-a-residencia.png",
    RISCO_VIDA: "/marker-icons/incendio/riscos-a-vida.png",
    PREJUIZO_MATERIAL: "/marker-icons/incendio/prejuizos-materiais.png",
    DEGRADACAO_AMBIENTAL: "/marker-icons/incendio/degradacao-ambiental.png",
    IMPACTOS_SAUDE_PUBLICA: "/marker-icons/incendio/impactos-a-saude-publica.png",
    DANOS_HUMANOS: "/marker-icons/deslizamento/danos-humanos.png",
    DANOS_MATERIAIS: "/marker-icons/deslizamento/danos-materiais.png",
    DANOS_AMBIENTAIS: "/marker-icons/deslizamento/danos-ambientais.png",
    AGUA: "/marker-icons/quimicos/agua.png",
    AR: "/marker-icons/quimicos/ar.png",
    SOLO: "/marker-icons/quimicos/solo.png",
    TREMOR: "/marker-icons/tremor/tremor.png",
};
export const getSubCategoryImage = (subCategory) => {
    if (!subCategory) {
        return `${process.env.PUBLIC_URL}/marker-icons/default.png`;
    }
    return `${process.env.PUBLIC_URL}${markerImages[subCategory] ?? "/marker-icons/default.png"}`;
};
